import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {ApiResponse, BaseModalComponent, GLOBAL, UserModel} from 'common-shared';
import {UserService} from '../user.service';
import {BehaviorSubject} from "rxjs";
import {takeUntil} from "rxjs/operators";
@Component({
  selector: 'mes-user-edit-modal',
  templateUrl: './user-edit-modal.component.html',
})
export class UserEditModalComponent extends BaseModalComponent implements OnInit {
  entityId: string;
  entityName: string;
  response: ApiResponse<any>;
  user: UserModel;
  isPristine$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  isCurrentUserEditMode: boolean = false;
  @Output() add = new EventEmitter<UserModel>();

  constructor(private userService: UserService) {
    super();
  }

  ngOnInit() {
    if (this.entityId) {
      const load$ = this.isCurrentUserEditMode ? this.userService.getCurrentUserViewModel() : this.userService.loadOne(this.entityId);
      load$.pipe(takeUntil(this.componentDestroyed)).subscribe(value => this.user = value);
    } else {
      this.user = UserModel.CreateDefault({Fullname: this.entityName});
    }
  }

  onChanged(isPristine: boolean) {
    this.isPristine$.next(isPristine);
  }

  save(withClose: boolean = true) {
    const save$ = this.isCurrentUserEditMode ? this.userService.saveCurrentUser(this.user) : this.userService.save(this.user);
    save$.pipe(takeUntil(this.componentDestroyed)).subscribe({
      next: value => {
        if (withClose) {
          this.close(value.Id)
        }
      },
      error: value1 => this.response = value1.error
    });
  }

  delete() {
    this.userService.remove(this.user).pipe(takeUntil(this.componentDestroyed)).subscribe({
      next: () => this.close(),
      error: value1 => this.response = value1.error
    });
  }
}
